function handleIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting && window.innerWidth >= 990) {
      let index = entry.target.dataset.for;
      let nextImage = document.querySelector(
        `.about-sticky-image[data-for="${index}"]`
      );
      let allImages = document.querySelectorAll(`.about-sticky-image`);

      if (nextImage && !nextImage.classList.contains("img-active")) {
        allImages &&
          allImages.forEach((image) => {
            if (image.dataset.for == nextImage.dataset.for) {
              image.classList.add("img-active");
            } else {
              image.classList.remove("img-active");
            }
          });
      }
    }
  });
}

const options = {
  root: null,
  rootMargin: "0px",
  threshold: 1,
};

const observer = new IntersectionObserver(handleIntersection, options);
document.querySelectorAll(".about-item").forEach((i) => {
  observer.observe(i);
});
